module.exports = __webpack_public_path__ + "static/media/stockhausen_folkwang_11.cf53261c.jpg";